






















import { computed, defineComponent } from '@nuxtjs/composition-api';
import { PRODUCT_COLOR_ID, STYLE_INFO_LIST, SPARKLING_ADDITIONAL_LIST } from '~/constants';
import { WineColorText } from '~/enums';

export default defineComponent({
  props: {
    wineColor: {
      type: String,
      default: '',
    },
    wineColorId: {
      type: String,
      default: '',
    },
    styleId: {
      type: Number,
      required: true,
    },
    textSize: {
      type: String,
      default: 'text-sm',
    },
    typePadding: {
      type: String,
      default: 'p-0.5',
    },
    isChangeSparklingColor: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const style = computed(() => {
      let bgClassName = '';
      let textClassName = '';
      let styleName = '';
      STYLE_INFO_LIST.some((list) => {
        return list.styles.some((style) => {
          if (style.style_id === props.styleId) {
            bgClassName = style.bg_color_class;
            textClassName = style.text_class;
            styleName = style.type;
          }
          return style.style_id === props.styleId;
        });
      });
      if (props.isChangeSparklingColor) {
        const sparklingColorInfo = () =>
          SPARKLING_ADDITIONAL_LIST.find((sparking) => sparking.colorId === props.wineColorId);
        const sparklingStyle = () => sparklingColorInfo()?.styles.find((style) => style.style_id === props.styleId);
        if (sparklingStyle()) {
          bgClassName = sparklingStyle()?.bg_color_class ?? '';
          textClassName = sparklingStyle()?.text_class ?? '';
        }
      }
      return {
        bgClass: bgClassName,
        textClass: textClassName,
        label: styleName,
      };
    });

    const type = computed(() => {
      if (props.wineColor) {
        // 商品詳細画面の場合
        if (props.isChangeSparklingColor) {
          switch (props.wineColor) {
            case WineColorText.RED_SPARKLING:
              return '赤スパークリングワイン';
            case WineColorText.WHITE_SPARKLING:
              return '白スパークリングワイン';
            case WineColorText.ROSE_SPARKLING:
              return 'ロゼスパークリングワイン';
            default:
              return props.wineColor;
          }
        }
        switch (props.wineColor) {
          case WineColorText.RED:
            return '赤';
          case WineColorText.WHITE:
            return '白';
          case WineColorText.ROSE:
            return 'ロゼ';
          case WineColorText.RED_SPARKLING:
          case WineColorText.WHITE_SPARKLING:
          case WineColorText.ROSE_SPARKLING:
          case WineColorText.SPARKLING_WINE:
            return '泡';
          case WineColorText.ORANGE:
            return '橙';
          default:
            break;
        }
      }
      if (props.wineColorId) {
        switch (props.wineColorId) {
          case PRODUCT_COLOR_ID.RED:
            return '赤';
          case PRODUCT_COLOR_ID.WHITE:
            return '白';
          case PRODUCT_COLOR_ID.ROSE:
            return 'ロゼ';
          case PRODUCT_COLOR_ID.SPARKLING_RED:
          case PRODUCT_COLOR_ID.SPARKLING_WHITE:
          case PRODUCT_COLOR_ID.SPARKLING_ROSE:
          case PRODUCT_COLOR_ID.SPARKLING:
            return '泡';
          case PRODUCT_COLOR_ID.ORANGE:
            return '橙';
          default:
            break;
        }
      }
    });

    return { style, type };
  },
});
